import React from "react";
import { Navigate } from "react-router-dom";
import { UserManagement, USER_TYPES } from "../../modules/user-management";
import TenantContextBanner from "../../components/common/TenantContextBanner";
import useAuth from "../../hooks/useAuth";

const TenantUsers = () => {
  const { isSystemUser, activeTenantId } = useAuth();

  if (isSystemUser && !activeTenantId) {
    return <Navigate to="/tenantmgmt" replace />;
  }

  return (
    <>
      {isSystemUser ? <TenantContextBanner /> : null}
      <UserManagement userType={USER_TYPES.TENANT} />
    </>
  );
};

export default TenantUsers;
